import * as React from "react";
import { Menu, Image, Header, Popup, Dimmer } from "semantic-ui-react";
import Feedback from "../Feedback/Feedback";
import styles from "./PageTitle.module.scss";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { logout } from "../AuthProvider/AuthProvider";
import koneLogo from "../../images/kone-logo-blue.svg";
import bubble from "../../images/bubble.svg";
import userBlue from "../../images/userBlue.svg";
import gear from "../../images/gear.svg";
import logoutIcon from "../../images/exit-blue.svg";
import refresh from "../../images/refresh.svg";
import versionNumber from "../../utils/versionNumber.json";
import { urlToDocumentTitle } from "../../utils/utils";

export type PageTitleProps = {
  activeSubmenu: State.Submenu;
  handleSubmenuSelection: (submenu: State.Submenu) => void;
  handleReloadSelected: () => void;
  activeUser: Api.User | undefined;
};



export type Props = PageTitleProps & RouteComponentProps;

export type PageTitleState = {
  isFeedbackOpen: boolean;
};

/** PageTitle component */
class PageTitle extends React.PureComponent<Props, PageTitleState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isFeedbackOpen: false
    };
  }
  componentDidMount() {
    document.title = urlToDocumentTitle(window.location.pathname);
  }

  componentDidUpdate() {
    document.title = urlToDocumentTitle(window.location.pathname);
  }

  render(): JSX.Element {
    const { handleReloadSelected, activeUser } = this.props;
    return (
      <div className={styles.menuContainer}>
        <Menu className={styles.menu} borderless={true}>
          <Menu.Menu position="left">
            <Menu.Item className={styles.menuItem}>
              <Header
                as="h2"
                className={styles.header}
                onClick={() => this.props.history.push("/")}
              >
                {"KCE Database Tools"}
              </Header>
            </Menu.Item>
            <Menu.Item className={styles.menuItem}>
              <p className={styles.version}>
                {versionNumber.major}.{versionNumber.minor}.{versionNumber.sprint}.{versionNumber.build}
              </p>
            </Menu.Item>
          </Menu.Menu>
          <Menu.Menu position="right">
            <Menu.Item className={styles.menuItem} onClick={this.toggleFeedbackOpen}>
              <Image
                className={styles.outlinedIcon}
                src={bubble}
                id="feedbackIcon"
                alt="feedbackIcon"
              />
              <p className={styles.username}>Give Feedback</p>
            </Menu.Item>

            <Menu.Item className={styles.menuItem}>
              <Popup
                on="click"
                trigger={
                  <div className="flex-row-centered">
                    <Image
                      className={styles.outlinedIcon}
                      src={userBlue}
                      id="userIcon"
                      alt="userIcon"
                    />
                    <p className={styles.username}>{activeUser?.adAccount}</p>
                  </div>
                }
                // eslint-disable-next-line react/no-children-prop
                children={
                  <div className={["flex-column", styles.userMenuLinks].join(" ")}>
                    <div
                      className="flex-row-centered"
                      onClick={() => this.props.history.push("/profile")}
                    >
                      <img src={userBlue} className={styles.userMenuIcon} alt="user" />
                      <span>My Profile</span>
                    </div>
                    <div className="flex-row-centered" onClick={() => logout()}>
                      <img src={logoutIcon} className={styles.userMenuIcon} alt="logout" />
                      <span>Logout</span>
                    </div>
                  </div>
                }
              />
            </Menu.Item>

            <Menu.Item
              className={styles.menuItem}
              onClick={() => this.props.history.push("/setting")}
            >
              <Image className={styles.settingIcon} src={gear} id="gearIcon" alt="Settings" />
            </Menu.Item>
            <Menu.Item className={styles.menuItem} onClick={handleReloadSelected}>
              <Popup
                trigger={
                  <img className={styles.refreshIcon} src={refresh} id="reload" alt="reload" />
                }
                content={"Fetch all data"}
              />
            </Menu.Item>
            <Menu.Item>
              <Image
                onClick={() => this.props.history.push("/")}
                className={styles.koneLogo}
                src={koneLogo}
                id="koneLogo"
                alt="koneLogo"
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        {this.state.isFeedbackOpen && (
          <Dimmer active={true} page={true}>
            <div className={styles.FeedbackFormWrapper}>
              <Feedback close={this.toggleFeedbackOpen} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  private toggleFeedbackOpen = () => {
    this.setState(prevState => ({ isFeedbackOpen: !prevState.isFeedbackOpen }));
  };
  private getRoles = (): string => {
    const { activeUser } = this.props;
    if (!activeUser) return "";
    let toBeReturned = "(";
    activeUser.roles.map(role => (toBeReturned += role.name + ", "));
    toBeReturned = toBeReturned.slice(0, toBeReturned.length - 2);
    toBeReturned += ")";
    return toBeReturned;
  };
}

export default withRouter(PageTitle);

